export default {"src":"/_next/static/media/data.8e369dd4.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};